import { Box, CircularProgress } from "@mui/material";
import InfoBlock from "./InfoBlock";
import RoomInput from "../components/Inputs/RoomInput";

const EditRooms = ({ isLoading, currentSchedule, disciplineId, specialityId }) => {
  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={200} />
        </Box>
      ) : (
        <>
          <InfoBlock
            currentSchedule={currentSchedule}
            disciplineId={disciplineId}
            specialityId={specialityId}
          />
          <RoomInput
            classTypeId={currentSchedule?.classTypeId}
            disciplineId={disciplineId}
          />
        </>
      )}
    </>
  );
};

export default EditRooms;
